module.exports = __webpack_public_path__ + "static/img/home_logo.426a5c5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_logo.gif
// module id = uFPf
// module chunks = 3